import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const AndersImage = (props) => {
  const data = useStaticQuery(graphql`
    query {
      andersImage: file(
        relativePath: {
          eq: "components/pages/AboutPage/Sections/PressSection/AndersImage/anders.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 700, maxHeight: 400, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return <Img fluid={data.andersImage.childImageSharp.fluid} {...props} />
}

export default AndersImage
